import React, { Fragment } from "react";
import moment from "moment";
import {
  TypographyT40,
  TypographyT41,
  TypographyT42,
} from "Components/Common/Typography/index";
import {
  TBody,
  THead,
  Table,
  TableWrapper,
  Td,
  Th,
  Tr,
} from "Components/Common/Table/TableT1";
const ShipmentDetailsTable = (props) => {
  const { uploadShipmentDetailsList } = props;
  const getFailedMessage = (data = []) => {
    if (data.length === 0) {
      return "-";
    } else {
      return data.join(",");
    }
  };
  return (
    <Fragment>
      <TableWrapper>
        <Table>
          <THead>
            <Tr>
              <Th>File Name</Th>
              <Th>Upload Date</Th>
              <Th>Status</Th>
              <Th>Success Files</Th>
              <Th>Failed Files</Th>
              <Th>Failed Message</Th>
            </Tr>
          </THead>
          <TBody>
            {uploadShipmentDetailsList.map((ele, ind) => {
              return (
                <Fragment key={ele.exim_id}>
                  <Tr>
                    <Td>
                      <TypographyT40>{ele.file_name}</TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>
                        {moment(ele.created).format("DD/MM/YYYY")}
                      </TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT40>{ele.status}</TypographyT40>
                    </Td>
                    <Td>
                      <TypographyT41>{ele.count_success}</TypographyT41>
                    </Td>
                    <Td>
                      <TypographyT42>{ele.count_failed}</TypographyT42>
                    </Td>
                    <Td>
                      <TypographyT40>
                        {getFailedMessage(ele.error_message)}
                      </TypographyT40>
                    </Td>
                  </Tr>
                </Fragment>
              );
            })}
          </TBody>
        </Table>
      </TableWrapper>
    </Fragment>
  );
};

export default ShipmentDetailsTable;
